import { action, makeObservable, observable } from 'mobx';
import { deepCopy } from '@pascal/pascal-core';
import { gameColors } from '../enums/gameColors';

class BetTypesStore {
  initialBetTypesActiveBets = {
    [gameColors.Blue]: 0,
    [gameColors.Red]: 0,
    [gameColors.Green]: 0,
    [gameColors.Yellow]: 0,
  };

  betTypes = [];

  selectedType = null;

  betTypesActiveBets = deepCopy(this.initialBetTypesActiveBets);

  constructor() {
    makeObservable(this, {
      betTypes: observable.deep,
      betTypesActiveBets: observable.deep,
      selectedType: observable,
      setBetTypes: action.bound,
      setSelectedType: action.bound,
      updateBetTypesActiveBets: action.bound,
      resetBetTypesActiveBets: action.bound,
    });
  }

  setBetTypes(types) {
    this.betTypes = [...types];
  }

  setSelectedType(data) {
    this.selectedType = data;
  }

  updateBetTypesActiveBets(betType) {
    this.betTypesActiveBets[betType]++;
  }

  resetBetTypesActiveBets() {
    this.betTypesActiveBets = this.initialBetTypesActiveBets;
  }
}

export const betTypesStore = new BetTypesStore();
